export default __webpack_public_path__ + "static/media/html.8daa82ad.svg";